import { css } from '@emotion/css';
import { theme } from 'core/theme';

export const root = css`
  background-color: ${theme.palette.custom.footer};
`;
